export default __webpack_public_path__ + "static/demo-background-e271ca8a3d08cbe61342cdd08cc7aaab.png";